import * as WindowManagement from "@/services/windowManagement";
import { WindowKeys } from "@/services/windowManagement";

export enum HookKeys {
    ADD_TO_WISHLIST = "ADD_TO_WISHLIST"
}

export default class HooksService {
    private static registery: { [key: string]: (() => void)[] } = {};

    static register(key: HookKeys, callback: () => void) {
        HooksService.registery[key] ||= [];
        HooksService.registery[key].push(callback);
    }

    static hasCallbacksFor(key: HookKeys) {
        const cbs = HooksService.registery[key] || [];
        return cbs.length > 0;
    }

    static triggerCallback(key: HookKeys) {
        HooksService.getCallbacksFor(key).forEach((callback) => callback());
    }

    static getCallbacksFor(key: HookKeys): (() => void)[] {
        if (!HooksService.hasCallbacksFor(key)) {
            return [];
        }
        return HooksService.registery[key];
    }
}

const init = () => {
    WindowManagement.saveObject(WindowKeys.HOOKS, HooksService);
};

export { init };
